import React, { useMemo } from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import ForgotPasswordMessage from "../../utils/Enums";
import { passwordRegex } from "../../schemas/changePasswordSchema";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const PassWordRequirement = ({password="", className=""}) => {
    const requirements = useMemo(() => ForgotPasswordMessage.REQUIREMENTS, []);
    const passWordRegexList = useMemo(() => Object.values(passwordRegex), []);

  return (
    <List className={className}>
      {requirements.map((requirement, index) => (
        <ListItem
          key={`requirementlist-${index}`}
          className="change-password-form-list-item"
        >
          <ListItemIcon className="change-password-form-list-item-icon">
            {passWordRegexList[index].test(password) ? (
              <CheckCircleIcon className="check-circle-icon" />
            ) : (
              <RadioButtonUncheckedIcon className="unchecked-circle-icon" />
            )}
          </ListItemIcon>
          <ListItemText
            className="user-create-new-password-info"
            primary={requirement}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default React.memo(PassWordRequirement);
